import React, { Component } from "react";
import { Row, Col, Card, CardBody, FormGroup, Button,  Label, Input, Container, Spinner, Modal, ModalHeader, ModalBody, } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { validateToken, has_Permission } from '../../helpers/jwt-token-access/accessToken'
import Dropzone from "react-dropzone";
import Select from "react-select";
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import { Link } from "react-router-dom";
import axios from "axios";
//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';
import { BaseUrl } from "../../helpers/Baseurl"
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

const TypeGroup = [
	{ 
		label: "Type",
		options: [
                { label: "Air", value: "Air" },
                { label: "Land", value: "Land" },
                { label: "Water", value: "Water" },
		]
	}
];

class AddActivity extends Component {
  constructor(props) {
    super(props);
    this.obj = JSON.parse(localStorage.getItem("authUser"))
    if (!this.obj){
        this.props.history.push('/logout')
    }else if (!validateToken(this.obj.access)){
        this.props.history.push('/logout')
    }
    if(!has_Permission(this.obj.user, 4, 'create' )){
      this.props.history.push('/activities')
    }
    this.state = {
      loading: false,
      loadingstate: false,
      typeloading:false,
      model_type:false,

      selectedFiles: [],
      rejectedFiles:[],
      selectedActivity: { label: "Select Activity", value: null },
      selectedType : { label: "Land", value: "Land" },
      ActivityGroup:[],
      PlaceGroup: [],
      selectedPlace: {label: "Select Place", value: null },
      selectedDestination: { label: "Select Destination", value: "" },
      DestinationGroup:[],


      breadcrumbItems: [
        { title: "Activities", link: "/activities" },
        { title: "Add New Activity", link: "#" },
      ],
      
    };
    toastr.options = {
      positionClass: "toast-top-right",
      closeButton: "true",
      progressBar: "true",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
      showDuration: 300,
      hideDuration: 1000,
      timeOut: 5000,
      extendedTimeOut: 1000
  }
  
    this.onPlaceInputChange = this.onPlaceInputChange.bind(this)
    this.onInputChange = this.onInputChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleActivityTypeSubmit = this.handleActivityTypeSubmit.bind(this);
    this.handleselectedActivityGroup = this.handleselectedActivityGroup.bind(this);
    this.handleselectedPlaceGroup = this.handleselectedPlaceGroup.bind(this);
    this.handleSelectDestinationGroup = this.handleSelectDestinationGroup.bind(this);
    this.handleselectedTypeGroup = this.handleselectedTypeGroup.bind(this);
    this.tog_type = this.tog_type.bind(this);

  }


  tog_type() {
    this.setState(prevState => ({
      model_type: !prevState.model_type
    }));
    this.removeBodyCss();
  }
  removeBodyCss() {
    document.body.classList.add("no_padding");
  }

  componentDidCatch(error) {
    // Changing the state to true
    // if some error occurs
    console.log(error)
    toastr.error("Something Went Wrong", "")
    this.props.history.push('/activities')
  }

  async componentDidMount() {
    await this.loadTypesData()
    await this.loadDestinationData('?parent=null')
 }

 handleAcceptedFiles = files => {
  files.map(file =>
    Object.assign(file, {
      preview: URL.createObjectURL(file),
      formattedSize: this.formatBytes(file.size)
      })
    );
  this.setState({ selectedFiles: files });
  };

  handleRejectedFiles = files => {
    files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: this.formatBytes(file.size)
      })
    );
    this.setState({ rejectedFiles : files });
  } 

  formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };

  async loadDestinationData(filer_queryset){

    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
    };
    await fetch(`${BaseUrl}/api/locations/location/locations/${filer_queryset}`,requestOptions)
        .then(res => res.json())
        .then(
            (data) => {
                let options = []
                data.results.map(destination => {
                    options.push({ label: destination.name, value: destination.id })
                  })
               
                  let DestinationGroup = [
                    { 
                        label: "Destination",
                        options: options
                    }
                ];
                this.setState({ DestinationGroup:DestinationGroup  })      
               
            },
            (error) => {
                console.log(error, 'error--------------') 
            }
        )  
   }
  
  async loadPlacesData(filer_queryset){
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
    };
    await fetch(`${BaseUrl}/api/locations/location/locations/${filer_queryset}`,requestOptions)
        .then(res => res.json())
        .then(
            (data) => {
                let options = []
                data.results.map(place => {
                    options.push({ label: place.name, value: place.id })
                  })
              
                  let PlaceGroup = [
                    { 
                        label: "Places",
                        options: options
                    }
                ];
                this.setState({ PlaceGroup:PlaceGroup  })      
              
            },
            (error) => {
                console.log(error, 'error--------------') 
            }
        )  
  } 

  async loadTypesData(){

    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
    };
    await fetch(`${BaseUrl}/api/activities/activities_types/`,requestOptions)
        .then(res => res.json())
        .then(
            (data) => {
                let options = []
                data.map(activity => {
                  options.push({ label: activity.name, value: activity.id })
                })
                let ActivityGroup = [
                  { 
                    label: "Activity",
                    options: options
                  }
                ];
                this.setState({ ActivityGroup: ActivityGroup, })           
               
            },
            (error) => {
                console.log(error, 'error--------------') 
            }
        )  
   }

  onInputChange(e){
    this.loadDestinationData(`?parent=null&search=${e}`)
  }

  onPlaceInputChange(e){
    if (this.state.selectedDestination.value)
      this.loadPlacesData(`?parent__id=${this.state.selectedDestination.value}&search=${e}`)
  }

   handleselectedActivityGroup = selectedActivity =>{
    this.setState({ selectedActivity })
  }

  handleselectedPlaceGroup = selectedPlace =>{
    this.setState({ selectedPlace })
  }
  handleSelectDestinationGroup = selectedDestination => {
    this.loadPlacesData(`?parent__id=${selectedDestination.value}`)
    let selectedPlace = {label: "Select Place", value: null }
    this.setState({ selectedDestination, selectedPlace });
  };

  handleActivityTypeSubmit(e, values) {
    this.setState({ typeloading: true })
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
        body: JSON.stringify(values)
        };
        fetch(`${BaseUrl}/api/activities/activities_types/`,requestOptions)
              .then(res => 
                  {if(res.status >= 400){
                      res.json()
                      .then(
                          (data) =>{  
                            console.log(data, "---data")
                            toastr.error("Something Went Wrong", "") 
                            this.setState({ typeloading: false })
                          }     
                      )
                  }
                  else{
                      res.json()
                      .then(
                          (data) =>{
                          let selectedActivity ={ label: data.name, value: data.id }
                          this.setState({typeloading: false, model_type: false, selectedActivity:selectedActivity })
                          this.loadTypesData()
                          }
                      )
                  }    
              }
          )
  }

  handleselectedTypeGroup = selectedType =>{
    this.setState({ selectedType })
  }

  // Create New Activity 
  handleSubmit(e, values) {
    let description = document.getElementById("textarea").value
      if(! this.state.selectedActivity.value){
        toastr.error(`Select Activity`,"") 
      }else if(this.state.selectedFiles.length === 0){

        toastr.error(`Select Images`,"") 
      }else if (this.state.selectedPlace === null){
        
        toastr.error(`Select Activity Place`,"") 
      }else{
        this.setState({ loading: true })

        const formData = new FormData();
        const img = this.state.selectedFiles
        for(let i=0 ; i<img.length; i++){
          formData.append(
            "image",
            this.state.selectedFiles[i]
        );
        }
        formData.append("name",values.name)
        formData.append("activity",this.state.selectedActivity.value)
        formData.append("place",this.state.selectedPlace.value)
        formData.append("destination",this.state.selectedDestination.value)
        formData.append("contact",values.contact)
        formData.append("contact_person", values.contact_person)
        formData.append("activity_type",this.state.selectedType.value)        
        formData.append("agency", values.agency)
        formData.append("agency_contact", values.agency_contact )
        formData.append("address", values.address)
        formData.append("zip_code", values.zip_code)
        formData.append("description", description)
        formData.append("created_by",this.obj.user.id)
        
        axios.post(
          `${BaseUrl}/api/activities/add_activity/`,
          formData,
          {
              headers: {
                  "Content-type": "multipart/form-data",
                  "Authorization": `Bearer ${this.obj.access}`
              },                    
          }
      )
      .then(res => {
          toastr.success(`${res.data.activity.name} Added Successfully`,"") 
          this.props.history.push(`/activity-pricing/${res.data.id}`)
      })
      .catch(err => {
        toastr.error(`Somthing Went Wrong`,"") 
        this.setState({ loading: false })
          console.log(err, "----------------------error");
      })
      }
    }

  render() {
    const {ActivityGroup, selectedActivity, selectedPlace, PlaceGroup,selectedType,selectedDestination, DestinationGroup } = this.state

    const ActivityType = ({ innerRef, innerProps, isDisabled, children }) =>
    !isDisabled ? (
        <div id="add_state" ref={innerRef} {...innerProps} className="customReactSelectMenu">
            {children}
            <Link to="#" onClick={this.tog_type}  className="text-warning"><i className="mdi mdi-plus font-size-18"></i></Link>
        </div>
    ) : null;

    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs title="Add New Activity" breadcrumbItems={this.state.breadcrumbItems} />
            <AvForm className="needs-validation" enctype="multipart/form-data" onValidSubmit={this.handleSubmit} >
              <Row>
                <Col xl="6">
                  <Card>
                    <CardBody> 
                      <h4 className="card-title">Activity Detail</h4>
                      <Row>
                          <Col md="12">
                                <div className="mb-3">
                                  <Label className="form-label " htmlFor="name">Name</Label>
                                  <AvField
                                    name="name"
                                    placeholder="Activity Name"
                                    type="text"
                                    errorMessage="Enter Activity Name"
                                    className="form-control"
                                    validate={{ required: { value: true } }}
                                    id="name"
                                    
                                  />
                                </div>
                            </Col> 

                        </Row> 
                        <Row>
                          <Col md="6">
                                <div className="mb-3">
                                    <Label className="form-label">Activity</Label>
                                    <Select 
                                    value={selectedActivity}
                                    onChange={this.handleselectedActivityGroup}
                                    options={ActivityGroup}
                                    components={{ Menu: ActivityType }}
                                    classNamePrefix="select2-selection"
                                    />

                                </div>
                            </Col>
                            <Col md="6">
                                <div className="mb-3">
                                    <Label className="form-label">Type</Label>
                                    <Select 
                                    value={selectedType}
                                    onChange={this.handleselectedTypeGroup}
                                    options={TypeGroup}
                                    classNamePrefix="select2-selection"
                                    />

                                </div>
                            </Col>

                        </Row>
                        <Row>
                          <div className="mb-3">
                            <Label className="form-label " htmlFor="price">Description</Label>
                              <Input
                                type="textarea"
                                id="textarea"
                                rows="3"
                                placeholder="About Activity"
                              />
                          </div>
                        </Row>                    
                        <Row>
                            <Col md="12">
                            <Dropzone
                                    accept='.jpeg,.jpg,.JPG,.JPEG,.PNG,.png'
                                    maxSize={1000000}
                                    onDrop = {(acceptedFiles, fileRejections) => {
                                      this.handleRejectedFiles(fileRejections)
                                      this.handleAcceptedFiles(acceptedFiles)
                                      }}
                                >
                                    {({ getRootProps, getInputProps }) => (
                                    <div className="dropzone">
                                        <div
                                        className="dz-message needsclick"
                                        {...getRootProps()}
                                        >
                                        <input {...getInputProps()} />
                                        <div className="mb-3">
                                            <i className="display-4 text-muted ri-upload-cloud-2-line"></i>
                                        </div>
                                        <h6>Drop only .jpeg/.jpg/.png Images here or click to upload.</h6>
                                        <h6>Images size is less than 1 MB.</h6>
                                        </div>
                                    </div>
                                    )}
                                </Dropzone>
                                <div
                                    className="dropzone-previews mt-3"
                                    id="file-previews"
                                >
                                    {this.state.selectedFiles.map((f, i) => {
                                    return (
                                        <Card
                                        className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                        key={i + "-file"}
                                        >
                                        <div className="p-2">
                                            <Row className="align-items-center">
                                            <Col className="col-auto">
                                                <img
                                                data-dz-thumbnail=""
                                                height="80"
                                                className="avatar-sm rounded bg-light"
                                                alt={f.name}
                                                src={f.preview}
                                                />
                                            </Col>
                                            <Col>
                                                <Link
                                                to="#"
                                                className="text-muted fw-bold"
                                                >
                                                {f.name}
                                                </Link>
                                                <p className="mb-0">
                                                <strong>{f.formattedSize}</strong>
                                                </p>
                                            </Col>
                                            </Row>
                                        </div>
                                        </Card>
                                    );
                                    })}
                                  {this.state.rejectedFiles.length > 0?
                                    <>
                                      <hr></hr>
                                      <p style={{ color: "red", padding: 5, margin: 0, fontSize: 14 }}>
                                        {"Rejected Files: File size is grater than 1 MB or Invalid File Format"}
                                      </p>
                                    </>
                                  :""}
                                  {this.state.rejectedFiles.map((f, i) => {
                                    return (
                                        <Card
                                        className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                        key={i + "-rejected_file"}
                                        >
                                        <div className="p-2">
                                            <Row className="align-items-center">
                                            <Col className="col-auto">
                                                <img
                                                data-dz-thumbnail=""
                                                height="80"
                                                className="avatar-sm rounded bg-light"
                                                alt={f.name}
                                                src={f.preview}
                                                />
                                            </Col>
                                            <Col>
                                                <Link
                                                to="#"
                                                className="text-muted fw-bold"
                                                >
                                                {f.name}
                                                </Link>
                                                <p className="mb-0">
                                                <strong>{f.formattedSize}</strong>
                                                </p>
                                            </Col>
                                            </Row>
                                        </div>
                                        </Card>
                                      );
                                      })}
                                </div>
                            </Col>
                        </Row>    

                    </CardBody>
                  </Card>
                </Col>
                <Col xl="6">
                  <Card>
                    <CardBody> 
                      <h4 className="card-title">Additional Detail</h4>
                        <Row>
                          <Col md="6">
                              <div className="mb-3">
                                <Label className="form-label " htmlFor="elevation">Contact Person</Label>
                                <AvField
                                  name="contact_person"
                                  placeholder="Contact Person"
                                  type="text"
                                  errorMessage="Enter Contact Person"
                                  className="form-control"
                                  validate={{ required: { value: true } }}
                                  id="elevation"
                                  
                                />
                              </div>
                          </Col> 
                          <Col md="6">
                            <div className="mb-3">
                              <Label className="form-label " htmlFor="contact"> Contact Number</Label>
                                <AvField
                                  name="contact"
                                  placeholder="Contact Number"
                                  type="number"
                                  className="form-control"
                                  errorMessage="Enter Only Number"
                                  validate={{
                                    required: { value: true },
                                      pattern: {
                                      value: "^[0-9]+$",
                                      errorMessage: "Only Numbers"
                                      }
                                  }}
                                  id="contact"
                                  
                                />
                              </div>
                          </Col> 
                        </Row>
                        <Row>
                          <Col md="6">
                              <div className="mb-3">
                                <Label className="form-label " htmlFor="agency">Agency Name</Label>
                                <AvField
                                  name="agency"
                                  placeholder="Agency Name"
                                  type="text"
                                  errorMessage="Enter Agency Name"
                                  className="form-control"
                                  validate={{ required: { value: true } }}
                                  id="agency"
                                  
                                />
                              </div>
                          </Col> 
                          <Col md="6">
                            <div className="mb-3">
                              <Label className="form-label " htmlFor="agency_contact">Agency Contact Number</Label>
                                <AvField
                                  name="agency_contact"
                                  placeholder="Agency Contact Number"
                                  type="number"
                                  className="form-control"
                                  errorMessage="Enter Only Number"
                                  validate={{
                                    required: { value: true },
                                      pattern: {
                                      value: "^[0-9]+$",
                                      errorMessage: "Only Numbers"
                                      }
                                  }}
                                  id="agency_contact"
                                  
                                />
                              </div>
                          </Col> 
                        </Row>
                        <Row>
                          <Col md="12">
                                <div className="mb-3">
                                  <Label className="form-label " htmlFor="address">Address</Label>
                                  <AvField
                                    name="address"
                                    placeholder="Agency Address"
                                    type="text"
                                    errorMessage="Enter Agency Address"
                                    className="form-control"
                                    validate={{ required: { value: true } }}
                                    id="address"
                                    
                                  />
                                </div>
                            </Col> 

                        </Row> 
                        <Row>
                          <Col md="6">
                              <div className="mb-3">
                                  <Label className="form-label">Destination</Label>
                                  <Select 
                                  onInputChange={this.onInputChange}
                                  value={selectedDestination}
                                  onChange={this.handleSelectDestinationGroup}
                                  options={DestinationGroup}
                                  classNamePrefix="select2-selection"
                                  />
                            </div>
                          </Col>
                          <Col md="6">
                            <div className="mb-3">
                                <Label className="form-label">Place</Label>
                                <Select 
                                onInputChange={this.onPlaceInputChange}
                                value={selectedPlace}
                                onChange={this.handleselectedPlaceGroup}
                                options={PlaceGroup}
                                classNamePrefix="select2-selection"
                                />

                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="6">
                            <div className="mb-3">
                              <AvField
                                name="zip_code"
                                label="Pin Code"
                                placeholder="Enter Only number"
                                type="number"
                                errorMessage="Enter Only Number"
                                validate={{
                                  required: { value: true },
                                  
                                  maxLength: {
                                    value: 6,
                                    errorMessage: "Numbers must be less than 7 digit"},
                                  minLength: {
                                    value: 6,
                                    errorMessage: "Numbers must be Grater than 5 digit"}   
                                }}
                              />
                            </div>
                          </Col> 
                          
                        </Row>


                                        
                        <FormGroup className="mb-1 mt-3">
                          {this.state.loading?(
                            <Spinner className="me-2 mt-2" color="primary" />
                          ):(
                            <div>
                        
                          <Button type="submit" color="primary" className="me-1">
                            Submit
                        </Button>{" "}
                          <Button type="button" onClick={() => this.props.history.goBack()} color="secondary">
                          
                            Cancel
                        </Button>
                        
                        </div>
                          )}
                        
                        
                      </FormGroup>      

                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </AvForm>
            <Row>
            <Col sm={6} md={4} xl={3} className="mt-4">
               
               <Modal
                 isOpen={this.state.model_type}
                 toggle={this.tog_type}
                 centered={true}
               >
                 <ModalHeader toggle={() => this.setState({ model_type: false })}>
                 Add Activity
                 </ModalHeader>
                 <ModalBody>
                   <AvForm className="needs-validation" onValidSubmit={this.handleActivityTypeSubmit} >
           
                     <Row>
                       <Col md="6">
                         <div className="mb-3">
                           <Label className="form-label " htmlFor="name"> Activity Name</Label>
                           <AvField
                             name="name"
                             placeholder="Activity"
                             type="text"
                             errorMessage="Enter Activity"
                             className="form-control"
                             validate={{ required: { value: true } }}
                             id="name"
                             
                           />
                         </div>
                       </Col> 
                     </Row>
                                       
                     <FormGroup className="mb-0">
                       {this.state.typeloading?(
                         <Spinner className="me-2 mt-2" color="primary" />
                       ):(
                         <div>
                     
                       <Button type="submit" color="primary" className="me-1">
                         Submit
                       </Button>
                       </div>
                         )}
                     </FormGroup>     
                   </AvForm>

                 </ModalBody>
               </Modal>
             </Col>
            </Row>

          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default AddActivity;
